var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('GlobalTitle', {
    staticClass: "valentine",
    attrs: {
      "title": _vm.subtitle,
      "text-color": _vm.textColor
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };